// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isJSON(data: any) {
  try {
    JSON.parse(data)
    return true
  } catch {
    return false
  }
}

export function decodeJWT(token: string): any {
  try {
    // JWT tem 3 partes separadas por pontos: header.payload.signature
    const parts = token.split('.')
    if (parts.length !== 3) {
      throw new Error('Token JWT inválido')
    }

    // Decodifica o payload (segunda parte)
    const payload = parts[1]
    // Adiciona padding se necessário
    const paddedPayload = payload + '='.repeat((4 - payload.length % 4) % 4)
    const decodedPayload = atob(paddedPayload)

    return JSON.parse(decodedPayload)
  } catch (error) {
    console.error('Erro ao decodificar JWT:', error)
    return null
  }
}

export function getNivelAcessoFromJWT(token: string): number | null {
  const decoded = decodeJWT(token)

  if (decoded?.nivelAcesso == null) return null

  const nivelAcesso = Number(decoded.nivelAcesso)

  return Number.isFinite(nivelAcesso) ? nivelAcesso : null
}

export function getVendedorIdFromJWT(token: string): number | null {
  try {
    const decoded = decodeJWT(token)
    if (decoded && decoded.vendedor) {
      return Number.parseInt(decoded.vendedor)
    }
    return null
  } catch (error) {
    console.error('Erro ao extrair vendedorId do JWT:', error)
    return null
  }
}
